













import { Component, Prop, Vue } from "vue-property-decorator";
import { IDomain } from "@/models/domains";

@Component({
  components: {
    "domains-grid-item": () =>
      import("@/components/app/admin/domains/domainsGridItem.vue")
  }
})
export default class DomainsGrid extends Vue {
  // Prop
  @Prop({ required: true })
  public data!: IDomain[];

  // Methods

  public redirectToDomain(domain: IDomain) {
    const url = `${location.protocol}//${domain.origin}${
      location.port ? `:${location.port}` : ""
    }`;

    window.open(url, "_blank");
  }
}
